<template>
    <div>
        <button
            class="btn btn-link settings-btn"
            :title="showPartsBase ? 'Hide parts search' : 'Show parts search'"
            @click="togglePartsBase"
        >
            <i class="fas fa-cog fa-lg"></i>
        </button>
        <div class="card card-profile mt-4">
            <div class="card-body">
                <div class="mt-4 pt-4 d-flex justify-content-between" v-if="loading">
                    <div class="spinner-border text-danger m-auto" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="mt-4 pt-4 row">
                    <div class="col-12">
                        <h3 class="text-uppercase text-danger">Profile Settings</h3>
                    </div>
                    <div class="col-12">
                        <div class="row mt-4">
                            <ul
                                class="tabs-wrapper"
                                style="display: flex; justify-content: space-around"
                            >
                                <li
                                    class="tab"
                                    :class="selectedTab === 'personal_data' ? 'active' : ''"
                                >
                                    <a href="javascript:;" @click="setTab('personal_data')"
                                        >Personal Info</a
                                    >
                                </li>
                                <li
                                    class="tab"
                                    :class="selectedTab === 'search_settings' ? 'active' : ''"
                                >
                                    <a href="javascript:;" @click="setTab('search_settings')"
                                        >Search Preferences</a
                                    >
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div v-if="selectedTab === 'personal_data'">
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label class="form-label">Username</label>
                                        <input
                                            type="email"
                                            class="form-control"
                                            v-model="username"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label class="form-label">Email</label>
                                        <input
                                            type="email"
                                            class="form-control"
                                            v-model="email"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label class="form-label">First Name</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="firstName"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label class="form-label">Last Name</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="lastName"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-12 d-flex justify-content-end">
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            disabled
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="This feature is currently disabled"
                                        >
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="selectedTab === 'search_settings'">
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <div class="field">
                                            <input
                                                id="switch_gsa"
                                                type="checkbox"
                                                name="switch_gsa"
                                                class="switch is-rounded is-info"
                                                v-model="showPartsBase"
                                            />
                                            <label for="switch_gsa" style="outline: none"
                                                >Include parts_base results</label
                                            >
                                        </div>
                                    </div>
                                    <div class="col-12 d-flex justify-content-end">
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            @click="update"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapStores } from 'pinia'
    import { toast } from 'vue3-toastify'
    import { useProfileStore } from '@/stores/profileStore'
    import { useSessionStore } from '@/stores/sessionStore'
    import { useUserStore } from '@/stores/userStore'

    export default {
        name: 'ProfileConfig',
        data() {
            return {
                loading: false,
                selectedTab: 'personal_data',
            }
        },
        async mounted() {
            await this.loadProfileSettings()
        },
        computed: {
            ...mapStores(useProfileStore, useSessionStore, useUserStore),
            username: {
                get() {
                    return this.profileStore.personalData.username || ''
                },
                set(value) {
                    this.profileStore.setPersonalData({
                        username: value || '',
                    })
                },
            },
            email: {
                get() {
                    return this.profileStore.personalData.email || ''
                },
                set(value) {
                    this.profileStore.setPersonalData({
                        email: value || '',
                    })
                },
            },
            firstName: {
                get() {
                    return this.profileStore.personalData.first_name || ''
                },
                set(value) {
                    this.profileStore.setPersonalData({
                        first_name: value || '',
                    })
                },
            },
            lastName: {
                get() {
                    return this.profileStore.personalData.last_name || ''
                },
                set(value) {
                    this.profileStore.setPersonalData({
                        last_name: value || '',
                    })
                },
            },
            showPartsBase: {
                get() {
                    return this.profileStore.includePartsBase
                },
                set(value) {
                    this.profileStore.setSearchSettings({
                        include_parts_base: Boolean(value),
                    })
                },
            },
        },
        methods: {
            async loadProfileSettings() {
                try {
                    await this.profileStore.fetchProfileSettings()
                } catch (error) {
                    console.error('Error:', error)
                }
            },
            async update() {
                try {
                    await this.profileStore.saveProfileSettings()
                    toast.success('Settings updated successfully!', {
                        position: 'top-right',
                        autoClose: 2000,
                    })
                } catch (error) {
                    console.error('Error:', error)
                }
            },
            setTab(tab) {
                this.selectedTab = tab
            },
            togglePartsBase() {
                this.showPartsBase = !this.showPartsBase
                this.update()
            },
        },
    }
</script>

<style scoped>
    .settings-btn {
        position: fixed;
        top: 12px;
        right: 18px;
        z-index: 1030;
        padding: 4px;
        color: #555;
    }
    .settings-btn:hover {
        color: #d9534f;
    }

    .text-danger {
        color: var(--color-brand-primary) !important;
    }

    .card-profile {
        max-width: 80vw;
        margin: 0 auto;
        background: var(--color-surface-canvas);
        border: 1px solid var(--color-border-default);
        border-top: 4px solid var(--color-brand-primary);
        border-radius: var(--radius-sm);
        box-shadow: var(--shadow-sm);
        color: var(--color-text-primary);
    }

    .card-profile .card-body {
        background: var(--color-surface-canvas);
        color: var(--color-text-primary);
    }

    .card-profile .form-label,
    .card-profile .field label {
        color: var(--color-text-primary);
    }

    .card-profile .form-control,
    .card-profile .form-control:disabled {
        background: var(--color-surface-subtle);
        color: var(--color-text-secondary);
        border-color: var(--color-border-muted);
        opacity: 1;
    }
</style>
